import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { Store } from '@ngrx/store';
import { merge, Observable, of, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, map, takeWhile, tap } from 'rxjs/operators';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import * as fromRoot from '../../../store';
import { Guid } from '../../guid';
import { getLoading } from '../loading';

@Component({
    selector: 'ef-loading-container',
    templateUrl: './loading-container.component.html',
    styleUrls: ['./loading-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class LoadingContainerComponent implements OnInit, OnDestroy {
    private _observables: Observable<any>[];
    @Input() public set observables(value: Observable<any>[]) {
        if (value && value.length) {
            this._observables = value.filter(x => !!x);
        } else {
            this._observables = [];
        }
    }
    public get observables(): Observable<any>[] {
        return this._observables;
    }

    @Input() public set loadingText(value: string) {
        this.log.verbose({ type: this.id, loadingText: value });
        if (value != null) {
            this.loadingText$ = of(value);
        }
        this._loadingTextSubject.next(value);
    }
    private _loadingTextSubject = new ReplaySubject<string>(1);

    @Input() public set loading(value: boolean) {
        this.log.verbose({ type: this.id, loading: value });
        this._loadingSubject.next(value);
    }
    private _loadingSubject = new ReplaySubject<boolean>(1);

    @Input() public set processing(value: boolean) {
        this.log.verbose({ type: this.id, processing: value });
        this._processingSubject.next(value);
    }
    private _processingSubject = new ReplaySubject<boolean>(1);

    private active = true;
    public loading$: Observable<boolean>;
    public processing$: Observable<boolean>;
    public loadingText$: Observable<string>;
    private id: string;
    constructor(
        private cdref: ChangeDetectorRef,
        private log: LoggingService,
        private store: Store<fromRoot.State>
    ) {
        this.id = 'LoadingContainerComponent_' + Guid.newGuid();
    }

    ngOnInit() {
        this.log.time(this.id);
        if (this.loading !== null && this.loading !== undefined) {
            this.log.timeEnd(this.id);
        } else {
            if (!(this.observables && this.observables.length > 0)) {
                this.loading$ = of(false);
                this.log.timeEnd(this.id);
                // return;
            }
        }

        this.loading$ = merge(
            this._loadingSubject,
            getLoading(this.observables, this.store)
        ).pipe(
            // share(),
            takeWhile(() => this.active),
            tap(loading => {
                this.log.timeLog(this.id);
                this.log.verbose({
                    type: `${this.id}:loading$`,
                    loading,
                    observables: this.observables
                });
            }),
            map(x => x),
            distinctUntilChanged()
        );

        this.loading$.pipe(takeWhile(() => this.active)).subscribe(loading => {
            this.cdref.detectChanges();
        });

        // merge(this.observables)
        //     .pipe(
        //         takeWhile(() => this.active),
        //         tap(observables =>
        //             this.log.verbose({
        //                 type: `${id}:observables`,
        //                 observables
        //             })
        //         )
        //     )
        //     .subscribe((x) => {
        //         // this.cdref.detectChanges();
        //         this.log.timeStamp(id);
        //     });
        this.cdref.detectChanges();
    }

    ngOnDestroy() {
        this.log.verbose({
            type: `${this.id}:ngOnDestroy`,
            observables: this.observables,
            loading: this.loading
        });
        this.active = false;
        this.log.timeEnd(this.id);
    }
}
